module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_3.8ef4f967.png";